import { routeFeatures } from "./features.config";

export const localizedPages = {
  // Profession / profession-task ("tevékenység") ajánlatkérés landings. The page
  // files live under English folders (pages/landing/request-tender/...); the URL
  // is localized here — Hungarian uses "ajanlatkeres"/"tevekenyseg". Only hu-HU
  // is reachable today (joszaki serves hu-HU only); the en-US paths apply
  // automatically if these landings ever run under another locale.
  "landing/request-tender/_professionSeoName": {
    "hu-HU": "/landing/ajanlatkeres/:professionSeoName",
    "en-US": "/landing/request-tender/:professionSeoName",
  },
  "landing/request-tender/profession-task/_professionTaskSeoName": {
    "hu-HU": "/landing/ajanlatkeres/tevekenyseg/:professionTaskSeoName",
    "en-US": "/landing/request-tender/profession-task/:professionTaskSeoName",
  },
  "blog/index": {
    "en-US": "/blog",
    "hu-HU": "/blog",
    "cs-CZ": "/blog",
    "de-DE": "/blog",
    "hr-HR": "/blog",
  },
  "blog/tag/_tagSeoName": {
    "en-US": "/blog/tag/:tagSeoName",
    "hu-HU": "/blog/cimke/:tagSeoName",
    "cs-CZ": "/blog/znacka/:tagSeoName",
    "de-DE": "/blog/tag/:tagSeoName",
    "hr-HR": "/blog/oznaka/:tagSeoName",
  },
  "blog/collection/_collectionSeoName": {
    "en-US": "/blog/collection/:collectionSeoName",
    "hu-HU": "/blog/gyujtemeny/:collectionSeoName",
    "cs-CZ": "/blog/kolekce/:collectionSeoName",
    "de-DE": "/blog/kollektion/:collectionSeoName",
    "hr-HR": "/blog/kolekcija/:collectionSeoName",
  },
  "blog/profession/_professionSeoName": {
    "en-US": "/blog/profession/:professionSeoName",
    "hu-HU": "/blog/szakma/:professionSeoName",
    "cs-CZ": "/blog/profese/:professionSeoName",
    "de-DE": "/blog/beruf/:professionSeoName",
    "hr-HR": "/blog/zanimanje/:professionSeoName",
  },
  "blog/professionTask/_professionTaskSeoName": {
    "en-US": "/blog/profession-task/:professionTaskSeoName",
    "hu-HU": "/blog/tevekenyseg/:professionTaskSeoName",
    "cs-CZ": "/blog/cinnost/:professionTaskSeoName",
    "de-DE": "/blog/aktivitat/:professionTaskSeoName",
    "hr-HR": "/blog/djelatnost/:professionTaskSeoName",
  },
  "close-tender/_personTenderId": {
    "en-US": "/close-tender/:personTenderId",
    "hu-HU": "/ajanlatkeres-lezarasa/:personTenderId",
    "cs-CZ": "/zadost-o-nabidku-zavrit/:personTenderId",
    "de-DE": "/angebot-schliessen/:personTenderId",
    "hr-HR": "/zatvori-ponudu/:personTenderId",
  },
  "blog/_articleSeoName": {
    "en-US": "/blog/:articleSeoName",
    "hu-HU": "/blog/:articleSeoName",
    "cs-CZ": "/blog/:articleSeoName",
    "de-DE": "/blog/:articleSeoName",
    "hr-HR": "/blog/:articleSeoName",
  },
  "request-for-tender/index": {
    "en-US": "/request-for-tender",
    "hu-HU": "/ajanlatkeres",
    "cs-CZ": "/zadost-o-nabidku",
    "de-DE": "/angebotsanfrage",
    "hr-HR": "/zahtjev-za-ponudu",
  },
  "request-for-tender/_activeTab": {
    "en-US": "/request-for-tender/:activeTab",
    "hu-HU": "/ajanlatkeres/:activeTab",
    "cs-CZ": "/zadost-o-nabidku/:activeTab",
    "de-DE": "/angebotsanfrage/:activeTab",
    "hr-HR": "/zahtjev-za-ponudu/:activeTab",
  },
  "request-for-tender/_activeTab/mate/_mateId": {
    "en-US": "/request-for-tender/:activeTab/mate/:mateId",
    "hu-HU": "/ajanlatkeres/:activeTab/szaki/:mateId",
    "cs-CZ": "/zadost-o-nabidku/:activeTab/profik/:mateId",
    "de-DE": "/angebotsanfrage/:activeTab/fachmann/:mateId",
    "hr-HR": "/zahtjev-za-ponudu/:activeTab/strucnjak/:mateId",
  },
  "tender/_tenderId/specify/index": {
    "en-US": "/tender/:tenderId/specify",
    "hu-HU": "/munka/:tenderId/pontositsunk",
    "cs-CZ": "/prace/:tenderId/specifikace",
    "de-DE": "/angebot/:tenderId/spezifikation",
    "hr-HR": "/ponuda/:tenderId/specifikacija",
  },
  "tender/_tenderId/specify/_activeTab": {
    "en-US": "/tender/:tenderId/specify/:activeTab",
    "hu-HU": "/munka/:tenderId/pontositsunk/:activeTab",
    "cs-CZ": "/prace/:tenderId/specifikace/:activeTab",
    "de-DE": "/angebot/:tenderId/spezifikation/:activeTab",
    "hr-HR": "/ponuda/:tenderId/specifikacija/:activeTab",
  },
  "prices/index": {
    "en-US": "/prices",
    "hu-HU": "/arak",
    "cs-CZ": "/ceny",
    "de-DE": "/preise",
    "hr-HR": "/cijene",
  },
  "prices/_professionTask": {
    "en-US": "/prices/:professionTask",
    "hu-HU": "/arak/:professionTask",
    "cs-CZ": "/ceny/:professionTask",
    "de-DE": "/preise/:professionTask",
    "hr-HR": "/cijene/:professionTask",
  },
  "price-calculator/_professionTask/_step": {
    "en-US": "/price-calculator/:professionTask/:step?",
    "hu-HU": "/arkalkulator/:professionTask/:step?",
    "cs-CZ": "/kalkulacka-cen/:professionTask/:step?",
    "de-DE": "/preiskalkulator/:professionTask/:step?",
    "hr-HR": "/kalkulator-cijena/:professionTask/:step?",
  },
  "profession/_professionGroup/index": {
    "en-US": "/profession/:professionGroup",
    "hu-HU": "/szakma/:professionGroup",
    "cs-CZ": "/profese/:professionGroup",
    "de-DE": "/beruf/:professionGroup",
    "hr-HR": "/zanimanje/:professionGroup",
  },
  "profession/index": {
    "en-US": "/profession",
    "hu-HU": "/szakma",
    "cs-CZ": "/profese",
    "de-DE": "/beruf",
    "hr-HR": "/zanimanje",
  },
  "login/index": {
    "en-US": "/login",
    "hu-HU": "/belepes",
    "cs-CZ": "/prihlaseni",
    "de-DE": "/anmeldung",
    "hr-HR": "/prijava",
  },
  "new-password/index": {
    "en-US": "/new-password",
    "hu-HU": "/uj-jelszo",
    "cs-CZ": "/nove-heslo",
    "de-DE": "/neues-passwort",
    "hr-HR": "/nova-lozinka",
  },
  "professionals/_profession/index": {
    "en-US": "/professionals/:profession",
    "hu-HU": "/szakemberek/:profession",
    "cs-CZ": "/odbornici/:profession",
    "de-DE": "/fachleute/:profession",
    "hr-HR": "/strucnjaci/:profession",
  },
  "professionals/_profession/szakivalaszol/_questionSeoName": {
    "en-US": "/professionals/:profession/questions/:questionSeoName",
    "hu-HU": "/szakemberek/:profession/szakivalaszol/:questionSeoName",
    "cs-CZ": "/odbornici/:profession/odpovedi-odborniku/:questionSeoName",
    "de-DE": "/fachleute/:profession/fragen/:questionSeoName",
    "hr-HR": "/strucnjaci/:profession/pitanja/:questionSeoName",
  },
  "professionals/_profession/_city/index": {
    "en-US": "/professionals/:profession/:city",
    "hu-HU": "/szakemberek/:profession/:city",
    "cs-CZ": "/odbornici/:profession/:city",
    "de-DE": "/fachleute/:profession/:city",
    "hr-HR": "/strucnjaci/:profession/:city",
  },
  "career/index": {
    "en-US": "/career",
    "hu-HU": "/karrier",
    "cs-CZ": "/kariera",
    "de-DE": "/karriere",
    "hr-HR": "/karijera",
  },
  "cities/index": {
    "en-US": "/cities",
    "hu-HU": "/telepules",
    "cs-CZ": "/mesta",
    "de-DE": "/stadte",
    "hr-HR": "/gradovi",
  },
  "counties/_county/_city/_subCity": {
    "en-US": "/counties/:county/:city/:subCity?",
    "hu-HU": "/megyek/:county/:city/:subCity?",
    "cs-CZ": "/kraje/:county/:city/:subCity?",
    "de-DE": "/bezirke/:county/:city/:subCity?",
    "hr-HR": "/zupanije/:county/:city/:subCity?",
  },
  "counties/_county/index": {
    "en-US": "/counties/:county",
    "hu-HU": "/megyek/:county",
    "cs-CZ": "/kraje/:county",
    "de-DE": "/bundeslander/:county",
    "hr-HR": "/zupanije/:county",
  },
  "price-offer/index": {
    "en-US": "/price-offer",
    "hu-HU": "/arajanlatkeszito",
    "cs-CZ": "/cenova-nabidka",
    "de-DE": "/preis-angebot",
    "hr-HR": "/cjenovna-ponuda",
  },
  "price-offer-registration/index": {
    "en-US": "/price-offer-registration",
    "hu-HU": "/arajanlatkeszito-regisztracio",
    "cs-CZ": "/registrace-cenove-nabidky",
    "de-DE": "/preis-angebot-registrierung",
    "hr-HR": "/registracija-cjenovne-ponude",
  },
  "professionals/_profession/_parentCity/_city/index": {
    "en-US": "/professionals/:profession/:parentCity/:city",
    "hu-HU": "/szakemberek/:profession/:parentCity/:city",
    "cs-CZ": "/odbornici/:profession/:parentCity/:city",
    "de-DE": "/fachleute/:profession/:parentCity/:city",
    "hr-HR": "/strucnjaci/:profession/:parentCity/:city",
  },
  "professional/_professionalSeoName/index": {
    "en-US": "/professional/:professionalSeoName",
    "hu-HU": "/szakember/:professionalSeoName",
    "cs-CZ": "/odbornik/:professionalSeoName",
    "de-DE": "/fachmann/:professionalSeoName",
    "hr-HR": "/strucnjak/:professionalSeoName",
  },
  "professional/_professionalSeoName/rating/index": {
    "en-US": "/professional/:professionalSeoName/rating",
    "hu-HU": "/szakember/:professionalSeoName/ertekeles",
    "cs-CZ": "/odbornik/:professionalSeoName/hodnoceni",
    "de-DE": "/fachmann/:professionalSeoName/bewertung",
    "hr-HR": "/strucnjak/:professionalSeoName/ocjena",
  },
  "professional/_professionalSeoName/admin/person-event-log": {
    "en-US": "/professional/:professionalSeoName/admin/person-event-log",
    "hu-HU": "/szakember/:professionalSeoName/admin/person-event-log",
    "cs-CZ": "/odbornik/:professionalSeoName/admin/person-event-log",
    "de-DE": "/fachmann/:professionalSeoName/admin/person-event-log",
    "hr-HR": "/strucnjak/:professionalSeoName/admin/person-event-log",
  },
  "professional/_professionalSeoName/admin/balance": {
    "en-US": "/professional/:professionalSeoName/admin/balance",
    "hu-HU": "/szakember/:professionalSeoName/admin/balance",
    "cs-CZ": "/odbornik/:professionalSeoName/admin/balance",
    "de-DE": "/fachmann/:professionalSeoName/admin/balance",
    "hr-HR": "/strucnjak/:professionalSeoName/admin/balance",
  },
  "professional/_professionalSeoName/admin/transfers": {
    "en-US": "/professional/:professionalSeoName/admin/transfers",
    "hu-HU": "/szakember/:professionalSeoName/admin/transfers",
    "cs-CZ": "/odbornik/:professionalSeoName/admin/transfers",
    "de-DE": "/fachmann/:professionalSeoName/admin/transfers",
    "hr-HR": "/strucnjak/:professionalSeoName/admin/transfers",
  },
  "professional/_professionalSeoName/admin/merge": {
    "en-US": "/professional/:professionalSeoName/admin/merge",
    "hu-HU": "/szakember/:professionalSeoName/admin/merge",
    "cs-CZ": "/odbornik/:professionalSeoName/admin/merge",
    "de-DE": "/fachmann/:professionalSeoName/admin/merge",
    "hr-HR": "/strucnjak/:professionalSeoName/admin/merge",
  },
  "new-professionals/index": {
    "en-US": "/new-professionals",
    "hu-HU": "/uj-szakik",
    "cs-CZ": "/novi-odbornici",
    "de-DE": "/neue-fachleute",
    "hr-HR": "/novi-strucnjaci",
  },
  "no-password/index": {
    "en-US": "/no-password",
    "hu-HU": "/nincs-jelszo",
    "cs-CZ": "/bez-hesla",
    "de-DE": "/kein-passwort",
    "hr-HR": "/bez-lozinke",
  },
  "registration/index": {
    "en-US": "/registration",
    "hu-HU": "/regisztracio",
    "cs-CZ": "/registrace",
    "de-DE": "/registrierung",
    "hr-HR": "/registracija",
  },
  "registration/_": {
    "en-US": "/registration/:_",
    "hu-HU": "/regisztracio/:_",
    "cs-CZ": "/registrace/:_",
    "de-DE": "/registrierung/:_",
    "hr-HR": "/registracija/:_",
  },
  "customer-registration/index": {
    "en-US": "/customer-registration",
    "hu-HU": "/ajanlatkeroi-regisztracio",
    "cs-CZ": "/registrace-klienta",
    "de-DE": "/kundenregistrierung",
    "hr-HR": "/registracija-kupca",
  },
  "registration/jobfeed/index": {
    "en-US": "/registration/jobfeed",
    "hu-HU": "/regisztracio/jobfeed",
    "cs-CZ": "/registrace/jobfeed",
    "de-DE": "/registrierung/jobfeed",
    "hr-HR": "/registracija/jobfeed",
  },
  "registration/email/index": {
    "en-US": "/registration/email",
    "hu-HU": "/regisztracio/email",
    "cs-CZ": "/registrace/email",
    "de-DE": "/registrierung/email",
    "hr-HR": "/registracija/email",
  },
  "registration/password/index": {
    "en-US": "/registration/password",
    "hu-HU": "/regisztracio/jelszo",
    "cs-CZ": "/registrace/heslo",
    "de-DE": "/registrierung/passwort",
    "hr-HR": "/registracija/lozinka",
  },
  "registration/city/index": {
    "en-US": "/registration/city",
    "hu-HU": "/regisztracio/varos",
    "cs-CZ": "/registrace/mesto",
    "de-DE": "/registrierung/stadt",
    "hr-HR": "/registracija/grad",
  },
  "registration/professions/index": {
    "en-US": "/registration/professions",
    "hu-HU": "/regisztracio/szakmak",
    "cs-CZ": "/registrace/profese",
    "de-DE": "/registrierung/berufe",
    "hr-HR": "/registracija/zanimanja",
  },
  "registration/phone/index": {
    "en-US": "/registration/phone",
    "hu-HU": "/regisztracio/telefonszam",
    "cs-CZ": "/registrace/tel-cislo",
    "de-DE": "/registrierung/telefonnummer",
    "hr-HR": "/registracija/telefon",
  },
  "registration/name/index": {
    "en-US": "/registration/name",
    "hu-HU": "/regisztracio/nev",
    "cs-CZ": "/registrace/jmeno",
    "de-DE": "/registrierung/name",
    "hr-HR": "/registracija/ime",
  },
  "registration/picture/index": {
    "en-US": "/registration/profile-pic",
    "hu-HU": "/regisztracio/profilkep",
    "cs-CZ": "/registrace/profilovka",
    "de-DE": "/registrierung/profilbild",
    "hr-HR": "/registracija/profilna-slika",
  },
  "registration/introduction/index": {
    "en-US": "/registration/introduction",
    "hu-HU": "/regisztracio/bemutatkozas",
    "cs-CZ": "/registrace/predstaveni",
    "de-DE": "/registrierung/vorstellung",
    "hr-HR": "/registracija/predstavljanje",
  },
  "registration/invoice/index": {
    "en-US": "/registration/invoice",
    "hu-HU": "/regisztracio/szamlakepesseg",
    "cs-CZ": "/registrace/fakturovani",
    "de-DE": "/registrierung/rechnung",
    "hr-HR": "/registracija/racun",
  },
  "registration/success/index": {
    "en-US": "/registration/success",
    "hu-HU": "/regisztracio/siker",
    "cs-CZ": "/registrace/uspech",
    "de-DE": "/registrierung/erfolg",
    "hr-HR": "/registracija/uspjeh",
  },
  "inspiration/profession-task/_professionTaskSeoName": {
    "en-US": "/inspiration/profession-task/:professionTaskSeoName",
    "hu-HU": "/inspiracio/tevekenyseg/:professionTaskSeoName",
    "cs-CZ": "/inspirace/cinnost/:professionTaskSeoName",
    "de-DE": "/inspiration/aktivitat/:professionTaskSeoName",
    "hr-HR": "/inspiracija/djelatnost/:professionTaskSeoName",
  },
  "inspiration/profession/_professionSeoName": {
    "en-US": "/inspiration/profession/:professionSeoName",
    "hu-HU": "/inspiracio/szakma/:professionSeoName",
    "cs-CZ": "/inspirace/profese/:professionSeoName",
    "de-DE": "/inspiration/beruf/:professionSeoName",
    "hr-HR": "/inspiracija/zanimanje/:professionSeoName",
  },
  "inspiration/index": {
    "en-US": "/inspiration",
    "hu-HU": "/inspiracio",
    "cs-CZ": "/inspirace",
    "de-DE": "/inspiration",
    "hr-HR": "/inspiracija",
  },
  "inspiration/_inspirationSeoName/index": {
    "en-US": "/inspiration/:inspirationSeoName",
    "hu-HU": "/inspiracio/:inspirationSeoName",
    "cs-CZ": "/inspirace/:inspirationSeoName",
    "de-DE": "/inspiration/:inspirationSeoName",
    "hr-HR": "/inspiracija/:inspirationSeoName",
  },
  "inspiration/_inspirationSeoName/_pictureSeoName/index": {
    "en-US": "/inspiration/:inspirationSeoName/:pictureSeoName",
    "hu-HU": "/inspiracio/:inspirationSeoName/:pictureSeoName",
    "cs-CZ": "/inspirace/:inspirationSeoName/:pictureSeoName",
    "de-DE": "/inspiration/:inspirationSeoName/:pictureSeoName",
    "hr-HR": "/inspiracija/:inspirationSeoName/:pictureSeoName",
  },
  "salaries/index": {
    "en-US": "/salaries",
    "hu-HU": "/szakifizetesek",
    "cs-CZ": "/platy",
    "de-DE": "/gehalter",
    "hr-HR": "/place",
  },
  "salary-checker/index": {
    "en-US": "/salary-checker",
    "hu-HU": "/szakifizu",
    "cs-CZ": "/kalkulacka-platu",
    "de-DE": "/gehaltsrechner",
    "hr-HR": "/provjera-place",
  },
  "salary-checker/average/_professionSeoName/index": {
    "en-US": "/salary-checker/average/:professionSeoName",
    "hu-HU": "/szakifizu/atlag/:professionSeoName",
    "cs-CZ": "/kalkulacka-platu/prumerny/:professionSeoName",
    "de-DE": "/gehaltsrechner/durchschnitt/:professionSeoName",
    "hr-HR": "/provjera-place/prosjek/:professionSeoName",
  },
  "salary-checker/average/_professionSeoName/jobs/index": {
    "en-US": "/salary-checker/average/:professionSeoName/jobs",
    "hu-HU": "/szakifizu/atlag/:professionSeoName/munkak",
    "cs-CZ": "/kalkulacka-platu/prumerny/:professionSeoName/prace",
    "de-DE": "/gehaltsrechner/durchschnitt/:professionSeoName/arbeiten",
    "hr-HR": "/provjera-place/prosjek/:professionSeoName/poslovi",
  },
  "email-confirm/index": {
    "en-US": "/email-confirm",
    "hu-HU": "/email-megerosites",
    "cs-CZ": "/potvrzeni-emailu",
    "de-DE": "/email-bestaetigung",
    "hr-HR": "/potvrda-emaila",
  },
  "questions/index": {
    "en-US": "/questions",
    "hu-HU": "/szakivalaszol",
    "cs-CZ": "/odpovedi-odborniku",
    "de-DE": "/fragen",
    "hr-HR": "/pitanja",
  },
  "questions/profession/_professionSeoName/index": {
    "en-US": "/questions/profession/:professionSeoName",
    "hu-HU": "/szakivalaszol/szakma/:professionSeoName",
    "cs-CZ": "/odpovedi-odborniku/profese/:professionSeoName",
    "de-DE": "/fragen/beruf/:professionSeoName",
    "hr-HR": "/pitanja/zanimanje/:professionSeoName",
  },
  "questions/profession-task/_professionTaskSeoName/index": {
    "en-US": "/questions/profession-task/:professionTaskSeoName",
    "hu-HU": "/szakivalaszol/tevekenyseg/:professionTaskSeoName",
    "cs-CZ": "/odpovedi-odborniku/cinnost/:professionTaskSeoName",
    "de-DE": "/fragen/aktivitat/:professionTaskSeoName",
    "hr-HR": "/pitanja/djelatnost/:professionTaskSeoName",
  },
  "questions/new-question/index": {
    "en-US": "/questions/new-question",
    "hu-HU": "/szakivalaszol/uj-kerdes",
    "cs-CZ": "/odpovedi-odborniku/nova-otazka",
    "de-DE": "/fragen/neue-frage",
    "hr-HR": "/pitanja/novo-pitanje",
  },
  "questions/_questionSeoName/index": {
    "en-US": "/questions/:questionSeoName",
    "hu-HU": "/szakivalaszol/:questionSeoName",
    "cs-CZ": "/odpovedi-odborniku/:questionSeoName",
    "de-DE": "/fragen/:questionSeoName",
    "hr-HR": "/pitanja/:questionSeoName",
  },
  "conductor/index": {
    "en-US": "/conductor",
    "hu-HU": "/vezerlo",
    "cs-CZ": "/conductor",
    "de-DE": "/conductor",
    "hr-HR": "/conductor",
  },
  "conductor/blog/index": {
    "en-US": "/conductor/blog",
    "hu-HU": "/vezerlo/blog",
    "cs-CZ": "/conductor/blog",
    "de-DE": "/conductor/blog",
    "hr-HR": "/conductor/blog",
  },
  "conductor/blog/articles/index": {
    "en-US": "/conductor/blog/articles",
    "hu-HU": "/vezerlo/blog/cikkek",
    "cs-CZ": "/conductor/blog/clanky",
    "de-DE": "/conductor/blog/artikel",
    "hr-HR": "/conductor/blog/clanci",
  },
  "conductor/blog/articles/_id/index": {
    "en-US": "/conductor/blog/articles/:id",
    "hu-HU": "/vezerlo/blog/cikkek/:id",
    "cs-CZ": "/conductor/blog/clanky/:id",
    "de-DE": "/conductor/blog/artikel/:id",
    "hr-HR": "/conductor/blog/clanci/:id",
  },
  "conductor/blog/articles/create/index": {
    "en-US": "/conductor/blog/articles/create",
    "hu-HU": "/vezerlo/blog/cikkek/letrehozas",
    "cs-CZ": "/conductor/blog/clanky/vytvorit",
    "de-DE": "/conductor/blog/artikel/erstellen",
    "hr-HR": "/conductor/blog/clanci/kreiraj",
  },
  "conductor/blog/collections/index": {
    "en-US": "/conductor/blog/collections",
    "hu-HU": "/vezerlo/blog/gyujtemenyek",
    "cs-CZ": "/conductor/blog/kolekce",
    "de-DE": "/conductor/blog/sammlungen",
    "hr-HR": "/conductor/blog/kolekcije",
  },
  "conductor/blog/collections/_id/index": {
    "en-US": "/conductor/blog/collections/:id",
    "hu-HU": "/vezerlo/blog/gyujtemenyek/:id",
    "cs-CZ": "/conductor/blog/kolekce/:id",
    "de-DE": "/conductor/blog/sammlungen/:id",
    "hr-HR": "/conductor/blog/kolekcije/:id",
  },
  "conductor/blog/collections/create/index": {
    "en-US": "/conductor/blog/collections/create",
    "hu-HU": "/vezerlo/blog/gyujtemenyek/letrehozas",
    "cs-CZ": "/conductor/blog/kolekce/vytvorit",
    "de-DE": "/conductor/blog/sammlungen/erstellen",
    "hr-HR": "/conductor/blog/kolekcije/kreiraj",
  },
  "conductor/blog/tags/index": {
    "en-US": "/conductor/blog/tags",
    "hu-HU": "/vezerlo/blog/cimkek",
    "cs-CZ": "/conductor/blog/znacky",
    "de-DE": "/conductor/blog/tags",
    "hr-HR": "/conductor/blog/oznake",
  },
  "conductor/blog/tags/_id/index": {
    "en-US": "/conductor/blog/tags/:id",
    "hu-HU": "/vezerlo/blog/cimkek/:id",
    "cs-CZ": "/conductor/blog/znacky/:id",
    "de-DE": "/conductor/blog/tags/:id",
    "hr-HR": "/conductor/blog/oznake/:id",
  },
  "conductor/blog/tags/create/index": {
    "en-US": "/conductor/blog/tags/create",
    "hu-HU": "/vezerlo/blog/cimkek/letrehozas",
    "cs-CZ": "/conductor/blog/znacky-vytvorit",
    "de-DE": "/conductor/blog/tags/erstellen",
    "hr-HR": "/conductor/blog/oznake/kreiraj",
  },
  "conductor/newsletter-subscriptions/index": {
    "en-US": "/conductor/newsletter-subscriptions",
    "hu-HU": "/vezerlo/hirlevel-feliratkozasok",
    "cs-CZ": "/conductor/newsletter-prihlasky",
    "de-DE": "/conductor/newsletter-abonnements",
    "hr-HR": "/conductor/pretplate-na-newsletter",
  },
  "conductor/notifications/index": {
    "en-US": "/conductor/notifications",
    "hu-HU": "/vezerlo/ertesitesek",
    "cs-CZ": "/conductor/oznameni",
    "de-DE": "/conductor/benachrichtigungen",
    "hr-HR": "/conductor/obavijesti",
  },
  "conductor/notifications/create/index": {
    "en-US": "/conductor/notifications/create",
    "hu-HU": "/vezerlo/ertesitesek/letrehozas",
    "cs-CZ": "/conductor/oznameni/vytvorit",
    "de-DE": "/conductor/benachrichtigungen/erstellen",
    "hr-HR": "/conductor/obavijesti/kreiraj",
  },
  "conductor/notifications/_id/index": {
    "en-US": "/conductor/notifications/:id",
    "hu-HU": "/vezerlo/ertesitesek/:id",
    "cs-CZ": "/conductor/oznameni/:id",
    "de-DE": "/conductor/benachrichtigungen/:id",
    "hr-HR": "/conductor/obavijesti/:id",
  },
  "conductor/professions/index": {
    "en-US": "/conductor/professions",
    "hu-HU": "/vezerlo/szakmak",
    "cs-CZ": "/conductor/profese",
    "de-DE": "/conductor/berufe",
    "hr-HR": "/conductor/zanimanja",
  },
  "conductor/professions/create/index": {
    "en-US": "/conductor/professions/create",
    "hu-HU": "/vezerlo/szakmak/letrehozas",
    "cs-CZ": "/conductor/profese/vytvorit",
    "de-DE": "/conductor/berufe/erstellen",
    "hr-HR": "/conductor/zanimanja/kreiraj",
  },
  "conductor/professions/_id/index": {
    "en-US": "/conductor/professions/:id",
    "hu-HU": "/vezerlo/szakmak/:id",
    "cs-CZ": "/conductor/profese/:id",
    "de-DE": "/conductor/berufe/:id",
    "hr-HR": "/conductor/zanimanja/:id",
  },
  "conductor/profession-task-pages/index": {
    "en-US": "/conductor/profession-task-pages",
    "hu-HU": "/vezerlo/tevekenyseg-oldalak",
    "cs-CZ": "/conductor/stranky-cinnosti",
    "de-DE": "/conductor/taetigkeitsseiten",
    "hr-HR": "/conductor/stranice-djelatnosti",
  },
  "conductor/profession-task-pages/create/index": {
    "en-US": "/conductor/profession-task-pages/create",
    "hu-HU": "/vezerlo/tevekenyseg-oldalak/letrehozas",
    "cs-CZ": "/conductor/stranky-cinnosti/vytvorit",
    "de-DE": "/conductor/taetigkeitsseiten/erstellen",
    "hr-HR": "/conductor/stranice-djelatnosti/kreiraj",
  },
  "conductor/profession-task-pages/select/index": {
    "en-US": "/conductor/profession-task-pages/select",
    "hu-HU": "/vezerlo/tevekenyseg-oldalak/kivalasztas",
    "cs-CZ": "/conductor/stranky-cinnosti/vyber",
    "de-DE": "/conductor/taetigkeitsseiten/auswahl",
    "hr-HR": "/conductor/stranice-djelatnosti/odabir",
  },
  "conductor/profession-task-pages/_id/index": {
    "en-US": "/conductor/profession-task-pages/:id",
    "hu-HU": "/vezerlo/tevekenyseg-oldalak/:id",
    "cs-CZ": "/conductor/stranky-cinnosti/:id",
    "de-DE": "/conductor/taetigkeitsseiten/:id",
    "hr-HR": "/conductor/stranice-djelatnosti/:id",
  },
  "conductor/profession-groups/index": {
    "en-US": "/conductor/profession-groups",
    "hu-HU": "/vezerlo/szakmacsoportok",
    "cs-CZ": "/conductor/skupiny-profesi",
    "de-DE": "/conductor/berufsgruppen",
    "hr-HR": "/conductor/grupe-zanimanja",
  },
  "conductor/profession-groups/create/index": {
    "en-US": "/conductor/profession-groups/create",
    "hu-HU": "/vezerlo/szakmacsoportok/letrehozas",
    "cs-CZ": "/conductor/skupiny-profesi/vytvorit",
    "de-DE": "/conductor/berufsgruppen/erstellen",
    "hr-HR": "/conductor/grupe-zanimanja/kreiraj",
  },
  "conductor/profession-groups/_id/index": {
    "en-US": "/conductor/profession-groups/:id",
    "hu-HU": "/vezerlo/szakmacsoportok/:id",
    "cs-CZ": "/conductor/skupiny-profesi/:id",
    "de-DE": "/conductor/berufsgruppen/:id",
    "hr-HR": "/conductor/grupe-zanimanja/:id",
  },
  "conductor/tenders/index": {
    "en-US": "/conductor/tenders",
    "hu-HU": "/vezerlo/ajanlatkeresek",
    "cs-CZ": "/conductor/zadosti-o-nabidku",
    "de-DE": "/conductor/angebotsanfragen",
    "hr-HR": "/conductor/ponude",
  },
  "conductor/tenders/list/index": {
    "en-US": "/conductor/tenders/list",
    "hu-HU": "/vezerlo/ajanlatkeresek/lista",
    "cs-CZ": "/conductor/zadosti-o-nabidku/seznam",
    "de-DE": "/conductor/angebotsanfragen/liste",
    "hr-HR": "/conductor/ponude/lista",
  },
  "conductor/tenders/create/index": {
    "en-US": "/conductor/tenders/create",
    "hu-HU": "/vezerlo/ajanlatkeresek/letrehozas",
    "cs-CZ": "/conductor/zadosti-o-nabidku/vytvorit",
    "de-DE": "/conductor/angebotsanfragen/erstellen",
    "hr-HR": "/conductor/ponude/kreiraj",
  },
  "conductor/tenders/_id/index": {
    "en-US": "/conductor/tenders/:id",
    "hu-HU": "/vezerlo/ajanlatkeresek/:id",
    "cs-CZ": "/conductor/zadosti-o-nabidku/:id",
    "de-DE": "/conductor/angebotsanfragen/:id",
    "hr-HR": "/conductor/ponude/:id",
  },
  "conductor/tenders/judge/index": {
    "en-US": "/conductor/tenders/judge",
    "hu-HU": "/vezerlo/ajanlatkeresek/biralas",
    "cs-CZ": "/conductor/zadosti-o-nabidku/posouzeni",
    "de-DE": "/conductor/angebotsanfragen/bewertung",
    "hr-HR": "/conductor/ponude/ocijeni",
  },
  "conductor/persons/index": {
    "en-US": "/conductor/persons",
    "hu-HU": "/vezerlo/felhasznalok",
    "cs-CZ": "/conductor/osoby",
    "de-DE": "/conductor/personen",
    "hr-HR": "/conductor/osobe",
  },
  "conductor/person-favourites/index": {
    "en-US": "/conductor/person-favourites",
    "hu-HU": "/vezerlo/kedvencek",
    "cs-CZ": "/conductor/oblibene",
    "de-DE": "/conductor/favoriten",
    "hr-HR": "/conductor/favoriti",
  },
  "conductor/persons/_id/index": {
    "en-US": "/conductor/persons/:id",
    "hu-HU": "/vezerlo/felhasznalok/:id",
    "cs-CZ": "/conductor/osoby/:id",
    "de-DE": "/conductor/personen/:id",
    "hr-HR": "/conductor/osobe/:id",
  },
  "conductor/job-feeds/index": {
    "en-US": "/conductor/crm/job-feeds",
    "hu-HU": "/vezerlo/crm/munkaertesitok",
    "cs-CZ": "/conductor/crm/pracovni-kanaly",
    "de-DE": "/conductor/crm/arbeitsfeed",
    "hr-HR": "/conductor/crm/obavijesti-o-poslovima",
  },
  "conductor/job-feeds/_id/index": {
    "en-US": "/conductor/crm/job-feeds/:id",
    "hu-HU": "/vezerlo/crm/munkaertesitok/:id",
    "cs-CZ": "/conductor/crm/pracovni-kanaly/:id",
    "de-DE": "/conductor/crm/arbeitsfeed/:id",
    "hr-HR": "/conductor/crm/obavijesti-o-poslovima/:id",
  },
  "conductor/leads/index": {
    "en-US": "/conductor/crm/leads",
    "hu-HU": "/vezerlo/crm/leadek",
    "cs-CZ": "/conductor/crm/potencialni-zakaznici",
    "de-DE": "/conductor/crm/leads",
    "hr-HR": "/conductor/crm/potencijalni-klijenti",
  },
  "conductor/leads/_id/index": {
    "en-US": "/conductor/crm/leads/:id",
    "hu-HU": "/vezerlo/crm/leadek/:id",
    "cs-CZ": "/conductor/crm/potencialni-zakaznici/:id",
    "de-DE": "/conductor/crm/leads/:id",
    "hr-HR": "/conductor/crm/potencijalni-klijenti/:id",
  },
  "conductor/lead-statuses/index": {
    "en-US": "/conductor/crm/lead-statuses",
    "hu-HU": "/vezerlo/crm/leadek/statuszok",
    "cs-CZ": "/conductor/crm/lead-statuses",
    "de-DE": "/conductor/crm/lead-statuses",
    "hr-HR": "/conductor/crm/lead-statuses",
  },
  "conductor/lead-owners/index": {
    "en-US": "/conductor/crm/lead-owners",
    "hu-HU": "/vezerlo/crm/leadek/felelosok",
    "cs-CZ": "/conductor/crm/lead-owners",
    "de-DE": "/conductor/crm/lead-owners",
    "hr-HR": "/conductor/crm/lead-owners",
  },
  "conductor/lead-tasks/index": {
    "en-US": "/conductor/crm/my-leads",
    "hu-HU": "/vezerlo/crm/leadek/feladatok",
    "cs-CZ": "/conductor/crm/my-leads",
    "de-DE": "/conductor/crm/my-leads",
    "hr-HR": "/conductor/crm/my-leads",
  },
  "conductor/crm/index": {
    "en-US": "/conductor/crm",
    "hu-HU": "/vezerlo/crm",
    "cs-CZ": "/conductor/crm",
    "de-DE": "/conductor/crm",
    "hr-HR": "/conductor/crm",
  },
  "conductor/crm/tasks/index": {
    "en-US": "/conductor/crm/my",
    "hu-HU": "/vezerlo/crm/feladataim",
    "cs-CZ": "/conductor/crm/my",
    "de-DE": "/conductor/crm/my",
    "hr-HR": "/conductor/crm/my",
  },
  "conductor/crm-professional-ticket-statuses/index": {
    "en-US": "/conductor/crm-professional-ticket-statuses",
    "hu-HU": "/vezerlo/crm/szakember-statuszok",
    "cs-CZ": "/conductor/crm-professional-ticket-statuses",
    "de-DE": "/conductor/crm-professional-ticket-statuses",
    "hr-HR": "/conductor/crm-professional-ticket-statuses",
  },
  "conductor/inspirations/index": {
    "en-US": "/conductor/inspirations",
    "hu-HU": "/vezerlo/inspiraciok",
    "cs-CZ": "/conductor/inspirace",
    "de-DE": "/conductor/inspirationen",
    "hr-HR": "/conductor/inspiracije",
  },
  "conductor/inspirations/create/index": {
    "en-US": "/conductor/inspirations/create",
    "hu-HU": "/vezerlo/inspiraciok/letrehozas",
    "cs-CZ": "/conductor/inspirace/vytvorit",
    "de-DE": "/conductor/inspirationen/erstellen",
    "hr-HR": "/conductor/inspiracije/kreiraj",
  },
  "conductor/inspirations/_id/index": {
    "en-US": "/conductor/inspirations/:id",
    "hu-HU": "/vezerlo/inspiraciok/:id",
    "cs-CZ": "/conductor/inspirace/:id",
    "de-DE": "/conductor/inspirationen/:id",
    "hr-HR": "/conductor/inspiracije/:id",
  },
  "conductor/questions/index": {
    "en-US": "/conductor/questions",
    "hu-HU": "/vezerlo/kerdesek",
    "cs-CZ": "/conductor/otazky",
    "de-DE": "/conductor/fragen",
    "hr-HR": "/conductor/pitanja",
  },
  "conductor/questions/_id/index": {
    "en-US": "/conductor/questions/:id",
    "hu-HU": "/vezerlo/kerdesek/:id",
    "cs-CZ": "/conductor/otazky/:id",
    "de-DE": "/conductor/fragen/:id",
    "hr-HR": "/conductor/pitanja/:id",
  },
  "conductor/mini-markets/index": {
    "en-US": "/conductor/mini-markets",
    "hu-HU": "/vezerlo/minipiacok",
    "cs-CZ": "/conductor/mini-trhy",
    "de-DE": "/conductor/mini-markte",
    "hr-HR": "/conductor/mini-trzista",
  },
  "conductor/mini-markets/create/index": {
    "en-US": "/conductor/mini-markets/create",
    "hu-HU": "/vezerlo/minipiacok/letrehozas",
    "cs-CZ": "/conductor/mini-trhy/vytvorit",
    "de-DE": "/conductor/mini-markte/erstellen",
    "hr-HR": "/conductor/mini-trzista/kreiraj",
  },
  "conductor/mini-markets/_id/index": {
    "en-US": "/conductor/mini-markets/:id",
    "hu-HU": "/vezerlo/minipiacok/:id",
    "cs-CZ": "/conductor/mini-trhy/:id",
    "de-DE": "/conductor/mini-markte/:id",
    "hr-HR": "/conductor/mini-trzista/:id",
  },
  "conductor/zones/index": {
    "en-US": "/conductor/profession-zones",
    "hu-HU": "/vezerlo/szakma-zonak",
    "cs-CZ": "/conductor/profesni-zony",
    "de-DE": "/conductor/berufs-zonen",
    "hr-HR": "/conductor/zone-zanimanja",
  },
  "conductor/zones/positions/index": {
    "en-US": "/conductor/profession-zones/positions",
    "hu-HU": "/vezerlo/szakma-zonak/helyezesek",
    "cs-CZ": "/conductor/profesni-zony/pozice",
    "de-DE": "/conductor/berufs-zonen/positionen",
    "hr-HR": "/conductor/zone-zanimanja/pozicije",
  },
  "conductor/zones/create/index": {
    "en-US": "/conductor/profession-zones/create",
    "hu-HU": "/vezerlo/szakma-zonak/letrehozas",
    "cs-CZ": "/conductor/profesni-zony/vytvorit",
    "de-DE": "/conductor/berufs-zonen/erstellen",
    "hr-HR": "/conductor/zone-zanimanja/kreiraj",
  },
  "conductor/zones/_id/index": {
    "en-US": "/conductor/profession-zones/:id",
    "hu-HU": "/vezerlo/szakma-zonak/:id",
    "cs-CZ": "/conductor/profesni-zony/:id",
    "de-DE": "/conductor/berufs-zonen/:id",
    "hr-HR": "/conductor/zone-zanimanja/:id",
  },
  "conductor/mini-market-teams/index": {
    "en-US": "/conductor/mini-market-teams",
    "hu-HU": "/vezerlo/zona-csapatok",
    "cs-CZ": "/conductor/tymy-mini-trhu",
    "de-DE": "/conductor/mini-markt-teams",
    "hr-HR": "/conductor/timovi-mini-trzista",
  },
  "conductor/mini-market-teams/create/index": {
    "en-US": "/conductor/mini-market-teams/create",
    "hu-HU": "/vezerlo/zona-csapatok/letrehozas",
    "cs-CZ": "/conductor/tymy-mini-trhu/vytvorit",
    "de-DE": "/conductor/mini-markt-teams/erstellen",
    "hr-HR": "/conductor/timovi-mini-trzista/kreiraj",
  },
  "conductor/mini-market-teams/_id/index": {
    "en-US": "/conductor/mini-market-teams/:id",
    "hu-HU": "/vezerlo/zona-csapatok/:id",
    "cs-CZ": "/conductor/tymy-mini-trhu/:id",
    "de-DE": "/conductor/mini-markt-teams/:id",
    "hr-HR": "/conductor/timovi-mini-trzista/:id",
  },
  "conductor/email-templates/index": {
    "en-US": "/conductor/email-templates",
    "hu-HU": "/vezerlo/email-sablonok",
    "cs-CZ": "/conductor/e-mailove-sablony",
    "de-DE": "/conductor/e-mail-vorlagen",
    "hr-HR": "/conductor/predlosci-emaila",
  },
  "conductor/email-templates/create/index": {
    "en-US": "/conductor/email-templates/create",
    "hu-HU": "/vezerlo/email-sablonok/letrehozas",
    "cs-CZ": "/conductor/e-mailove-sablony/vytvorit",
    "de-DE": "/conductor/e-mail-vorlagen/erstellen",
    "hr-HR": "/conductor/predlosci-emaila/kreiraj",
  },
  "conductor/email-templates/_id/index": {
    "en-US": "/conductor/email-templates/:id",
    "hu-HU": "/vezerlo/email-sablonok/:id",
    "cs-CZ": "/conductor/e-mailove-sablony/:id",
    "de-DE": "/conductor/e-mail-vorlagen/:id",
    "hr-HR": "/conductor/predlosci-emaila/:id",
  },
  "conductor/ratings/index": {
    "en-US": "/conductor/ratings",
    "hu-HU": "/vezerlo/ertekelesek",
    "cs-CZ": "/conductor/hodnoceni",
    "de-DE": "/conductor/bewertungen",
    "hr-HR": "/conductor/ocjene",
  },
  "conductor/ratings/_id/index": {
    "en-US": "/conductor/ratings/:id",
    "hu-HU": "/vezerlo/ertekelesek/:id",
    "cs-CZ": "/conductor/hodnoceni/:id",
    "de-DE": "/conductor/bewertungen/:id",
    "hr-HR": "/conductor/ocjene/:id",
  },
  "conductor/subcounties/index": {
    "en-US": "/conductor/subcounties",
    "hu-HU": "/vezerlo/jarasok",
    "cs-CZ": "/conductor/okresy",
    "de-DE": "/conductor/unterbezirke",
    "hr-HR": "/conductor/opcine",
  },
  "conductor/subcounties/create/index": {
    "en-US": "/conductor/subcounties/create",
    "hu-HU": "/vezerlo/jarasok/letrehozas",
    "cs-CZ": "/conductor/okresy/vytvorit",
    "de-DE": "/conductor/unterbezirke/erstellen",
    "hr-HR": "/conductor/opcine/kreiraj",
  },
  "conductor/subcounties/_id/index": {
    "en-US": "/conductor/subcounties/:id",
    "hu-HU": "/vezerlo/jarasok/:id",
    "cs-CZ": "/conductor/okresy/:id",
    "de-DE": "/conductor/unterbezirke/:id",
    "hr-HR": "/conductor/opcine/:id",
  },
  "conductor/superadmin/index": {
    "en-US": "/conductor/superadmin",
    "hu-HU": "/vezerlo/szuperadmin",
    "cs-CZ": "/conductor/superadmin",
    "de-DE": "/conductor/superadmin",
    "hr-HR": "/conductor/superadmin",
  },
  "conductor/service-types/index": {
    "en-US": "/conductor/service-types",
    "hu-HU": "/vezerlo/szolgaltatastipusok",
    "cs-CZ": "/conductor/typy-sluzeb",
    "de-DE": "/conductor/dienstleistungstypen",
    "hr-HR": "/conductor/tipovi-usluga",
  },
  "conductor/service-types/create/index": {
    "en-US": "/conductor/service-types/create",
    "hu-HU": "/vezerlo/szolgaltatastipusok/letrehozas",
    "cs-CZ": "/conductor/typy-sluzeb/vytvorit",
    "de-DE": "/conductor/dienstleistungstypen/erstellen",
    "hr-HR": "/conductor/tipovi-usluga/kreiraj",
  },
  "conductor/service-types/_id/index": {
    "en-US": "/conductor/service-types/:id",
    "hu-HU": "/vezerlo/szolgaltatastipusok/:id",
    "cs-CZ": "/conductor/typy-sluzeb/:id",
    "de-DE": "/conductor/dienstleistungstypen/:id",
    "hr-HR": "/conductor/tipovi-usluga/:id",
  },
  "conductor/flagged-contacts/index": {
    "en-US": "/conductor/flagged-contacts",
    "hu-HU": "/vezerlo/megjelolt-kapcsolatok",
    "cs-CZ": "/conductor/oznacene-kontakty",
    "de-DE": "/conductor/markierte-kontakte",
    "hr-HR": "/conductor/oznaceni-kontakti",
  },
  "conductor/flagged-contacts/create/index": {
    "en-US": "/conductor/flagged-contacts/create",
    "hu-HU": "/vezerlo/megjelolt-kapcsolatok/letrehozas",
    "cs-CZ": "/conductor/oznacene-kontakty/vytvorit",
    "de-DE": "/conductor/markierte-kontakte/erstellen",
    "hr-HR": "/conductor/oznaceni-kontakti/kreiraj",
  },
  "conductor/flagged-contacts/_id/index": {
    "en-US": "/conductor/flagged-contacts/:id",
    "hu-HU": "/vezerlo/megjelolt-kapcsolatok/:id",
    "cs-CZ": "/conductor/oznacene-kontakty/:id",
    "de-DE": "/conductor/markierte-kontakte/:id",
    "hr-HR": "/conductor/oznaceni-kontakti/:id",
  },
  "conductor/person-event-log-types/index": {
    "en-US": "/conductor/person-event-log-types",
    "hu-HU": "/vezerlo/hivasnaplo-tipusok",
    "cs-CZ": "/conductor/typy-zaznamu-komunikace",
    "de-DE": "/conductor/kommunikationsprotokoll-typen",
    "hr-HR": "/conductor/tipovi-zapisa-komunikacije",
  },
  "conductor/person-event-log-types/create/index": {
    "en-US": "/conductor/person-event-log-types/create",
    "hu-HU": "/vezerlo/hivasnaplo-tipusok/letrehozas",
    "cs-CZ": "/conductor/typy-zaznamu-komunikace/vytvorit",
    "de-DE": "/conductor/kommunikationsprotokoll-typen/erstellen",
    "hr-HR": "/conductor/tipovi-zapisa-komunikacije/kreiraj",
  },
  "conductor/person-event-log-types/_id/index": {
    "en-US": "/conductor/person-event-log-types/:id",
    "hu-HU": "/vezerlo/hivasnaplo-tipusok/:id",
    "cs-CZ": "/conductor/typy-zaznamu-komunikace/:id",
    "de-DE": "/conductor/kommunikationsprotokoll-typen/:id",
    "hr-HR": "/conductor/tipovi-zapisa-komunikacije/:id",
  },
  "conductor/virtual-phone-prefixes/index": {
    "en-US": "/conductor/virtual-phone-prefixes",
    "hu-HU": "/vezerlo/virtualis-telefonszamok",
    "cs-CZ": "/conductor/virtualni-telefonni-cisla",
    "de-DE": "/conductor/virtuelle-telefonnummern",
    "hr-HR": "/conductor/virtualni-telefonski-brojevi",
  },
  "conductor/virtual-phone-prefix-rules/index": {
    "en-US": "/conductor/virtual-phone-prefixes/rules",
    "hu-HU": "/vezerlo/virtualis-telefonszamok/szabalyok",
    "cs-CZ": "/conductor/virtualni-telefonni-cisla/pravidla",
    "de-DE": "/conductor/virtuelle-telefonnummern/regeln",
    "hr-HR": "/conductor/virtualni-telefonski-brojevi/pravila",
  },
  "conductor/virtual-phone-prefix-rules/create/index": {
    "en-US": "/conductor/virtual-phone-prefixes/rules/create",
    "hu-HU": "/vezerlo/virtualis-telefonszamok/szabalyok/letrehozas",
    "cs-CZ": "/conductor/virtualni-telefonni-cisla/pravidla/vytvorit",
    "de-DE": "/conductor/virtuelle-telefonnummern/regeln/erstellen",
    "hr-HR": "/conductor/virtualni-telefonski-brojevi/pravila/kreiraj",
  },
  "conductor/virtual-phone-prefix-rules/_id/index": {
    "en-US": "/conductor/virtual-phone-prefixes/rules/:id",
    "hu-HU": "/vezerlo/virtualis-telefonszamok/szabalyok/:id",
    "cs-CZ": "/conductor/virtualni-telefonni-cisla/pravidla/:id",
    "de-DE": "/conductor/virtuelle-telefonnummern/regeln/:id",
    "hr-HR": "/conductor/virtualni-telefonski-brojevi/pravila/:id",
  },
  "conductor/virtual-phone-prefix-assignments/index": {
    "en-US": "/conductor/virtual-phone-prefixes/assignments",
    "hu-HU": "/vezerlo/virtualis-telefonszamok/hozzarendelesek",
    "cs-CZ": "/conductor/virtualni-telefonni-cisla/prirazeni",
    "de-DE": "/conductor/virtuelle-telefonnummern/zuordnungen",
    "hr-HR": "/conductor/virtualni-telefonski-brojevi/dodjele",
  },
  "conductor/settings/index": {
    "en-US": "/conductor/settings",
    "hu-HU": "/vezerlo/beallitasok",
    "cs-CZ": "/vezerlo/nastaveni",
    "de-DE": "/vezerlo/einstellungen",
    "hr-HR": "/conductor/postavke",
  },
  "conductor/settings/create/index": {
    "en-US": "/conductor/settings/create",
    "hu-HU": "/vezerlo/beallitasok/letrehozas",
    "cs-CZ": "/vezerlo/nastaveni/vytvorit",
    "de-DE": "/vezerlo/einstellungen/erstellen",
    "hr-HR": "/conductor/postavke/kreiraj",
  },
  "conductor/settings/_id/index": {
    "en-US": "/conductor/settings/:id",
    "hu-HU": "/vezerlo/beallitasok/:id",
    "cs-CZ": "/vezerlo/nastaveni/:id",
    "de-DE": "/vezerlo/einstellungen/:id",
    "hr-HR": "/conductor/postavke/:id",
  },
  "conductor/services/index": {
    "en-US": "/conductor/services",
    "hu-HU": "/vezerlo/szolgaltatasok",
    "cs-CZ": "/conductor/sluzby",
    "de-DE": "/conductor/dienste",
    "hr-HR": "/conductor/usluge",
  },
  "conductor/services/create/index": {
    "en-US": "/conductor/services/create",
    "hu-HU": "/vezerlo/szolgaltatasok/letrehozas",
    "cs-CZ": "/conductor/sluzby/vytvorit",
    "de-DE": "/conductor/dienste/erstellen",
    "hr-HR": "/conductor/usluge/kreiraj",
  },
  "conductor/services/_id/index": {
    "en-US": "/conductor/services/:id",
    "hu-HU": "/vezerlo/szolgaltatasok/:id",
    "cs-CZ": "/conductor/sluzby/:id",
    "de-DE": "/conductor/dienste/:id",
    "hr-HR": "/conductor/usluge/:id",
  },
  "conductor/front-page-modules/index": {
    "en-US": "/conductor/front-page-modules",
    "hu-HU": "/vezerlo/fooldal-modulok",
    "cs-CZ": "/conductor/moduly-hlavni-stranky",
    "de-DE": "/conductor/startseite-module",
    "hr-HR": "/conductor/moduli-pocetne-stranice",
  },
  "conductor/profession-page-modules/index": {
    "en-US": "/conductor/profession-page-modules",
    "hu-HU": "/vezerlo/szakemberek-modulok",
    "cs-CZ": "/conductor/moduly-stranek-profesi",
    "de-DE": "/conductor/berufsseite-module",
    "hr-HR": "/conductor/moduli-stranica-zanimanja",
  },
  "conductor/request-tender-page-modules/index": {
    "en-US": "/conductor/request-tender-page-modules",
    "hu-HU": "/vezerlo/ajanlatkero-modulok",
    "cs-CZ": "/conductor/moduly-poptavkove-stranky",
    "de-DE": "/conductor/anfrage-module",
    "hr-HR": "/conductor/moduli-stranice-ponude",
  },
  "conductor/request-tender-page-modules/create/index": {
    "en-US": "/conductor/request-tender-page-modules/create",
    "hu-HU": "/vezerlo/ajanlatkero-modulok/letrehozas",
    "cs-CZ": "/conductor/moduly-poptavkove-stranky/vytvorit",
    "de-DE": "/conductor/anfrage-module/erstellen",
    "hr-HR": "/conductor/moduli-stranice-ponude/kreiraj",
  },
  "conductor/request-tender-page-modules/_id/index": {
    "en-US": "/conductor/request-tender-page-modules/:id",
    "hu-HU": "/vezerlo/ajanlatkero-modulok/:id",
    "cs-CZ": "/conductor/moduly-poptavkove-stranky/:id",
    "de-DE": "/conductor/anfrage-module/:id",
    "hr-HR": "/conductor/moduli-stranice-ponude/:id",
  },
  "conductor/request-tender-page-modules/funnel/index": {
    "en-US": "/conductor/request-tender-page-modules/conversion",
    "hu-HU": "/vezerlo/ajanlatkero-modulok/konverzio",
    "cs-CZ": "/conductor/moduly-poptavkove-stranky/konverze",
    "de-DE": "/conductor/anfrage-module/konversion",
    "hr-HR": "/conductor/moduli-stranice-ponude/konverzija",
  },
  "conductor/faqs/index": {
    "en-US": "/conductor/faqs",
    "hu-HU": "/vezerlo/gyik",
    "cs-CZ": "/conductor/caste-otazky",
    "de-DE": "/conductor/haeufig-gestellte-fragen",
    "hr-HR": "/conductor/cesta-pitanja",
  },
  "conductor/faqs/create/index": {
    "en-US": "/conductor/faqs/create",
    "hu-HU": "/vezerlo/gyik/letrehozas",
    "cs-CZ": "/conductor/caste-otazky/vytvorit",
    "de-DE": "/conductor/haeufig-gestellte-fragen/erstellen",
    "hr-HR": "/conductor/cesta-pitanja/kreiraj",
  },
  "conductor/faqs/_id/index": {
    "en-US": "/conductor/faqs/:id",
    "hu-HU": "/vezerlo/gyik/:id",
    "cs-CZ": "/conductor/caste-otazky/:id",
    "de-DE": "/conductor/haeufig-gestellte-fragen/:id",
    "hr-HR": "/conductor/cesta-pitanja/:id",
  },
  "conductor/faqs/manage/index": {
    "en-US": "/conductor/faqs/manage",
    "hu-HU": "/vezerlo/gyik/sorrend",
    "cs-CZ": "/conductor/caste-otazky/poradi",
    "de-DE": "/conductor/haeufig-gestellte-fragen/reihenfolge",
    "hr-HR": "/conductor/cesta-pitanja/redoslijed",
  },
  "conductor/faqs/groups/index": {
    "en-US": "/conductor/faqs/groups",
    "hu-HU": "/vezerlo/gyik/csoportok",
    "cs-CZ": "/conductor/caste-otazky/skupiny",
    "de-DE": "/conductor/haeufig-gestellte-fragen/gruppen",
    "hr-HR": "/conductor/cesta-pitanja/grupe",
  },
  "conductor/faqs/groups/create/index": {
    "en-US": "/conductor/faqs/groups/create",
    "hu-HU": "/vezerlo/gyik/csoportok/letrehozas",
    "cs-CZ": "/conductor/caste-otazky/skupiny/vytvorit",
    "de-DE": "/conductor/haeufig-gestellte-fragen/gruppen/erstellen",
    "hr-HR": "/conductor/cesta-pitanja/grupe/kreiraj",
  },
  "conductor/faqs/groups/_id/index": {
    "en-US": "/conductor/faqs/groups/:id",
    "hu-HU": "/vezerlo/gyik/csoportok/:id",
    "cs-CZ": "/conductor/caste-otazky/skupiny/:id",
    "de-DE": "/conductor/haeufig-gestellte-fragen/gruppen/:id",
    "hr-HR": "/conductor/cesta-pitanja/grupe/:id",
  },
  "conductor/legal-documents/index": {
    "en-US": "/conductor/legal-documents",
    "hu-HU": "/vezerlo/jogi-dokumentumok",
    "cs-CZ": "/conductor/pravni-dokumenty",
    "de-DE": "/conductor/rechtliche-dokumente",
    "hr-HR": "/conductor/pravni-dokumenti",
  },
  "conductor/legal-documents/create/index": {
    "en-US": "/conductor/legal-documents/create",
    "hu-HU": "/vezerlo/jogi-dokumentumok/letrehozas",
    "cs-CZ": "/conductor/pravni-dokumenty/vytvorit",
    "de-DE": "/conductor/rechtliche-dokumente/erstellen",
    "hr-HR": "/conductor/pravni-dokumenti/kreiraj",
  },
  "conductor/legal-documents/_id/index": {
    "en-US": "/conductor/legal-documents/:id",
    "hu-HU": "/vezerlo/jogi-dokumentumok/:id",
    "cs-CZ": "/conductor/pravni-dokumenty/:id",
    "de-DE": "/conductor/rechtliche-dokumente/:id",
    "hr-HR": "/conductor/pravni-dokumenti/:id",
  },
  "conductor/monitoring/funnels/index": {
    "en-US": "/conductor/monitoring/funnels",
    "hu-HU": "/vezerlo/monitoring/trendek",
    "cs-CZ": "/conductor/monitoring/funnels",
    "de-DE": "/conductor/monitoring/funnels",
    "hr-HR": "/conductor/monitoring/funnels",
  },
  "conductor/finance-transactions/import/index": {
    "en-US": "/conductor/finance-transactions/import",
    "hu-HU": "/vezerlo/banki-tranzakciok/importalas",
    "cs-CZ": "/conductor/finance-transactions/import",
    "de-DE": "/conductor/finance-transactions/import",
    "hr-HR": "/conductor/finance-transactions/import",
  },
  "my-account/favourites/index": {
    "en-US": "/my-account/favourites",
    "hu-HU": "/fiokom/kedvenceim",
    "cs-CZ": "/muj-ucet/moje-oblibene",
    "de-DE": "/mein-konto/meine-favoriten",
    "hr-HR": "/moj-racun/moji-favoriti",
  },
  "my-account/jobs-in-progress/index": {
    "en-US": "/my-account/jobs-in-progress",
    "hu-HU": "/fiokom/folyamatban-levo-munkaim",
    "cs-CZ": "/muj-ucet/probihajici-prace",
    "de-DE": "/mein-konto/laufende-arbeiten",
    "hr-HR": "/moj-racun/poslovi-u-tijeku",
  },
  "my-account/my-ratings/index": {
    "en-US": "/my-account/my-ratings",
    "hu-HU": "/fiokom/ertekeleseim",
    "cs-CZ": "/muj-ucet/moje-hodnoceni",
    "de-DE": "/mein-konto/meine-bewertungen",
    "hr-HR": "/moj-racun/moje-ocjene",
  },
  "my-account/my-tenders/index": {
    "en-US": "/my-account/my-tenders",
    "hu-HU": "/fiokom/ajanlatkereseim",
    "cs-CZ": "/muj-ucet/moje-poptavky",
    "de-DE": "/mein-konto/meine-angebotsanfragen",
    "hr-HR": "/moj-racun/moje-ponude",
  },
  "my-account/tile-designer/index": {
    "en-US": "/my-account/tile-designer",
    "hu-HU": "/fiokom/csempetervezo",
    "cs-CZ": "/muj-ucet/navrhar-dlazdic",
    "de-DE": "/mein-konto/fliesendesigner",
    "hr-HR": "/moj-racun/dizajner-plocica",
  },
  "my-account/designers/index": {
    "en-US": "/my-account/designers",
    "hu-HU": "/fiokom/tervezok",
    "cs-CZ": "/muj-ucet/navrhare",
    "de-DE": "/mein-konto/designer",
    "hr-HR": "/moj-racun/dizajneri",
  },
  "my-account/designers/_designerId/index": {
    "en-US": "/my-account/designers/:designerId",
    "hu-HU": "/fiokom/tervezok/:designerId",
    "cs-CZ": "/muj-ucet/navrhare/:designerId",
    "de-DE": "/mein-konto/designer/:designerId",
    "hr-HR": "/moj-racun/dizajneri/:designerId",
  },
  "my-account/plans/_planPublicId/index": {
    "en-US": "/my-account/plan/:planPublicId",
    "hu-HU": "/fiokom/terv/:planPublicId",
    "cs-CZ": "/muj-ucet/navrh/:planPublicId",
    "de-DE": "/mein-konto/plan/:planPublicId",
    "hr-HR": "/moj-racun/plan/:planPublicId",
  },
  "plan/_planPublicId/index": {
    "en-US": "/plan/:planPublicId",
    "hu-HU": "/terv/:planPublicId",
    "cs-CZ": "/navrh/:planPublicId",
    "de-DE": "/plan/:planPublicId",
    "hr-HR": "/plan/:planPublicId",
  },
  "my-account/obtainable-jobs/index": {
    "en-US": "/my-account/obtainable-jobs",
    "hu-HU": "/fiokom/megszerezheto-munkaim",
    "cs-CZ": "/muj-ucet/dostupne-prace",
    "de-DE": "/mein-konto/erhaltliche-arbeiten",
    "hr-HR": "/moj-racun/dostupni-poslovi",
  },
  "my-account/won-jobs/index": {
    "en-US": "/my-account/won-jobs",
    "hu-HU": "/fiokom/megnyert-munkaim",
    "cs-CZ": "/muj-ucet/vyhrane-zakazky",
    "de-DE": "/mein-konto/gewonnene-jobs",
    "hr-HR": "/moj-racun/osvojeni-poslovi",
  },
  "my-account/closed-jobs/index": {
    "en-US": "/my-account/closed-jobs",
    "hu-HU": "/fiokom/lezart-munkaim",
    "cs-CZ": "/muj-ucet/uzavrene-zakazky",
    "de-DE": "/mein-konto/geschlossene-jobs",
    "hr-HR": "/moj-racun/zatvoreni-poslovi",
  },
  "my-account/prices/index": {
    "en-US": "/my-account/prices",
    "hu-HU": "/fiokom/araim",
    "cs-CZ": "/muj-ucet/ceny",
    "de-DE": "/mein-konto/preise",
    "hr-HR": "/moj-racun/cijene",
  },
  "my-account/product-catalog/index": {
    "en-US": "/my-account/product-catalog",
    "hu-HU": "/fiokom/termek-katalogus",
    "cs-CZ": "/muj-ucet/katalog-produktu",
    "de-DE": "/mein-konto/produktkatalog",
    "hr-HR": "/moj-racun/katalog-proizvoda",
  },
  "my-account/references/index": {
    "en-US": "/my-account/references",
    "hu-HU": "/fiokom/referenciaim",
    "cs-CZ": "/muj-ucet/reference",
    "de-DE": "/mein-konto/referenzen",
    "hr-HR": "/moj-racun/reference",
  },
  "my-account/settings/_highlightedSetting": {
    "en-US": "/my-account/settings/:highlightedSetting?",
    "hu-HU": "/fiokom/beallitasaim/:highlightedSetting?",
    "cs-CZ": "/muj-ucet/nastaveni/:highlightedSetting?",
    "de-DE": "/mein-konto/einstellungen/:highlightedSetting?",
    "hr-HR": "/moj-racun/postavke/:highlightedSetting?",
  },
  "my-account/subscription/index": {
    "en-US": "/my-account/subscription",
    "hu-HU": "/fiokom/elofizetes",
    "cs-CZ": "/muj-ucet/predplatne",
    "de-DE": "/mein-konto/abonnement",
    "hr-HR": "/moj-racun/pretplata",
  },
  "my-account/subscription/_serviceTypeSeoName/index": {
    "en-US": "/my-account/subscription/:serviceTypeSeoName",
    "hu-HU": "/fiokom/elofizetes/:serviceTypeSeoName",
    "cs-CZ": "/muj-ucet/predplatne/:serviceTypeSeoName",
    "de-DE": "/mein-konto/abonnement/:serviceTypeSeoName",
    "hr-HR": "/moj-racun/pretplata/:serviceTypeSeoName",
  },
  "my-account/my-job/_personTenderId": {
    "en-US": "/my-account/my-job/:personTenderId",
    "hu-HU": "/fiokom/munkam/:personTenderId",
    "cs-CZ": "/muj-ucet/moje-prace/:personTenderId",
    "de-DE": "/mein-konto/meine-arbeit/:personTenderId",
    "hr-HR": "/moj-racun/moj-posao/:personTenderId",
  },
  "my-account/price-offers/index": {
    "en-US": "/my-account/price-offers",
    "hu-HU": "/fiokom/arajanlatok",
    "cs-CZ": "/muj-ucet/cenove-nabidky",
    "de-DE": "/mein-konto/preisangebote",
    "hr-HR": "/moj-racun/cjenovne-ponude",
  },
  "my-account/price-offers/_id/index": {
    "en-US": "/my-account/price-offers/:id",
    "hu-HU": "/fiokom/arajanlatok/:id",
    "cs-CZ": "/muj-ucet/cenove-nabidky/:id",
    "de-DE": "/mein-konto/preisangebote/:id",
    "hr-HR": "/moj-racun/cjenovne-ponude/:id",
  },
  "my-account/price-offers/new/index": {
    "en-US": "/my-account/price-offers/new",
    "hu-HU": "/fiokom/arajanlatok/uj",
    "cs-CZ": "/muj-ucet/cenove-nabidky/novy",
    "de-DE": "/mein-konto/preisangebote/neues",
    "hr-HR": "/moj-racun/cjenovne-ponude/novo",
  },
  "demo/price-offers/index": {
    "en-US": "/demo/price-offers",
    "hu-HU": "/demo/arajanlatok",
    "cs-CZ": "/demo/cenove-nabidky",
    "de-DE": "/demo/preisangebote",
    "hr-HR": "/demo/cjenovne-ponude",
  },
  "demo/price-offers/_id/index": {
    "en-US": "/demo/price-offers/:id",
    "hu-HU": "/demo/arajanlatok/:id",
    "cs-CZ": "/demo/cenove-nabidky/:id",
    "de-DE": "/demo/preisangebote/:id",
    "hr-HR": "/demo/cjenovne-ponude/:id",
  },
  "demo/price-offers/new/index": {
    "en-US": "/demo/price-offers/new",
    "hu-HU": "/demo/arajanlatok/uj",
    "cs-CZ": "/demo/cenove-nabidky/novy",
    "de-DE": "/demo/preisangebote/neues",
    "hr-HR": "/demo/cjenovne-ponude/novo",
  },
  "price-offer/_publicId/index": {
    "en-US": "/price-offer/:publicId",
    "hu-HU": "/arajanlat/:publicId",
    "cs-CZ": "/cena-nabidky/:publicId",
    "de-DE": "/preis-angebot/:publicId",
    "hr-HR": "/cjenovna-ponuda/:publicId",
  },
  "demo/price-offer/_publicId/index": {
    "en-US": "/demo/price-offer/:publicId",
    "hu-HU": "/demo/arajanlat/:publicId",
    "cs-CZ": "/demo/cena-nabidky/:publicId",
    "de-DE": "/demo/preis-angebot/:publicId",
    "hr-HR": "/demo/cjenovna-ponuda/:publicId",
  },
  "static/about-us/index": {
    "en-US": "/static/about-us",
    "hu-HU": "/static/rolunk",
    "cs-CZ": "/static/o-nas",
    "de-DE": "/static/uber-uns",
    "hr-HR": "/static/o-nama",
  },
  "static/faq/index": {
    "en-US": "/static/faq",
    "hu-HU": "/static/gyik",
    "cs-CZ": "/static/faq",
    "de-DE": "/static/faq",
    "hr-HR": "/static/faq",
  },
  "terms/index": {
    "en-US": "/terms",
    "hu-HU": "/aszf",
    "cs-CZ": "/vop",
    "de-DE": "/agb",
    "hr-HR": "/uvjeti",
  },
  "documents/index": {
    "en-US": "/documents",
    "hu-HU": "/dokumentumok",
    "cs-CZ": "/dokumenty",
    "de-DE": "/dokumente",
    "hr-HR": "/dokumenti",
  },
  "documents/cookies": {
    "en-US": "/documents/cookies",
    "hu-HU": "/dokumentumok/suti-tajekoztato",
    "cs-CZ": "/dokumenty/cookies",
    "de-DE": "/dokumente/cookies",
    "hr-HR": "/dokumenti/kolacici",
  },
  "documents/_type": {
    "en-US": "/documents/:type",
    "hu-HU": "/dokumentumok/:type",
    "cs-CZ": "/dokumenty/:type",
    "de-DE": "/dokumente/:type",
    "hr-HR": "/dokumenti/:type",
  },
  "oauth-register/index": {
    "en-US": "/oauth-register",
    "hu-HU": "/oauth-regisztracio",
    "cs-CZ": "/oauth-registrace",
    "de-DE": "/oauth-registrierung",
    "hr-HR": "/oauth-registracija",
  },
  "job-notification/index": {
    "en-US": "/job-notification",
    "hu-HU": "/munkaertesito",
    "cs-CZ": "/oznameni-o-praci",
    "de-DE": "/job-benachrichtigung",
    "hr-HR": "/obavijest-o-poslu",
  },
};

/**
 * Get feature flag for a given route name
 * Handles i18n-generated route names by stripping locale suffix
 * @param {string} routeName - The route name (e.g., "blogLandingPage___hu")
 * @returns {string|null} - The feature flag or null if not found
 */
export function getRouteFeature(routeName) {
  if (!routeName) return null;

  // Strip the i18n locale suffix (e.g., "blogLandingPage___hu" -> "blogLandingPage")
  const baseRouteName = routeName.split("___")[0];

  // Return the feature for this route name, or null if not found
  return routeFeatures[baseRouteName] || null;
}

// define all pages with their respective configurations
// create class responsible for returning current page, name, eventName
